var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show === true)?_c('div',{staticClass:"banner-messaging position-relative"},[_c('div',{staticClass:"messaging"},[_c('div',{class:[
        _vm.dismissible ? 'pl-4 pr-8' : 'px-4',
        'message-body',
        'text-center',
        _vm.classList !== '' ? _vm.classList : '' ]},[_vm._t("default")],2),_vm._v(" "),(_vm.dismissible)?_c('fa',{staticClass:"close-btn",attrs:{"icon":['fal', 'times']},on:{"click":function($event){_vm.show = false}}}):_vm._e()],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }